"use client";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { GridGalleryUI } from "./GridGalleryUI";
import { useSocialProofMessages } from "@/components/Galleries/hooks/useSocialProofMessages";
import {
  standardComponent,
  useStandardProps,
} from "@/context/StandardPropsContext/StandardPropsContext";
import { isM2MRomanBlindOrCurtain } from "@/utils/product/isMadeToMeasure.ts";
import { filterM2MImages } from "@/components/Galleries/utils/filterM2MImages.ts";
import { useRouter } from "next/router";

export const GridGallery = standardComponent("GridGallery", () => {
  const { product, sizes, configProps } = useStandardProps();
  const router = useRouter();
  const { variant } = useVariant(product);
  const { socialProofMessagesProperties } = useSocialProofMessages();

  const pdpAsLanding = configProps?.pdpAsLanding === true;

  if (!variant) return null;

  const media = "media" in product ? product.media : null;

  const videos = media?.videos || [];

  const title = variant.title;

  let images = variant.images;
  if (isM2MRomanBlindOrCurtain(product)) {
    images = filterM2MImages(images, router.query);
  }

  return (
    <GridGalleryUI
      title={title}
      images={images}
      videos={videos}
      sizes={sizes}
      hasSocialProofMessagesExperience={true}
      socialProofMessagesProperties={socialProofMessagesProperties}
      pdpAsLanding={pdpAsLanding}
    />
  );
});
